export default __webpack_public_path__ + "static/media/2.a6692477.jpg";